import { InstructionsList } from '@/features/instructions/components/list/InstructionsList'

export const InstructionsAdmin = () => <InstructionsList />
